import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {CompanyMaster} from "../data/common/company.shemas";
import {ResponseList} from "../models/common/Response";

export function useCompanyMaster() {
    return useQuery({
        queryKey: ['company-master'],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<CompanyMaster>>('/v1/company_master', {
                signal,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('LG_APPLICATION')}`,
                }
            }),
        select: response => response.data.result_list,
        refetchOnWindowFocus: false,
    });
}